import { useState, useCallback } from 'react';
import { useSpinner, useToast } from '@chikara/ui';
import { batchService } from '@/features/card/services/cardService/batchService';
import type { UseConfirmBatchReturn } from '@/features/card/types/card.types';
import { t } from '@/i18n';

export const useConfirmBatch = (): UseConfirmBatchReturn => {
    const { show, hide } = useSpinner();
    const { success } = useToast();
    const [error, setError] = useState<string | null>(null);

    const confirmBatch = useCallback(async (suitcase_uuid: string) => {
        show();
        setError(null);
        try {
            await batchService.confirmBatch(suitcase_uuid);
            success(t('dashboard.card.trackingDetail.success.confirmBatch'));
            return true;
        } catch (err) {
            setError(t('dashboard.card.trackingDetail.error.confirmBatch'));
            return false;
        } finally {
            hide();
        }
    }, [show, hide]);

    return { confirmBatch, error };
};
